"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SioClient = void 0;
var debug_1 = __importDefault(require("debug"));
var socket_io_client_1 = require("socket.io-client");
var debug = (0, debug_1.default)('rmf-client');
var SioClient = /** @class */ (function () {
    function SioClient() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._subscriptions = {};
        this.sio = socket_io_client_1.io.apply(void 0, __spreadArray([], __read(args), false));
    }
    SioClient.prototype.subscribe = function (room, listener) {
        var subs = this._subscriptions[room] || 0;
        if (subs === 0) {
            this.sio.emit('subscribe', { room: room });
            debug("subscribed to ".concat(room));
        }
        else {
            debug("reusing previous subscription to ".concat(room));
        }
        this.sio.on(room, listener);
        this._subscriptions[room] = subs + 1;
        return { room: room, listener: listener };
    };
    SioClient.prototype.unsubscribe = function (sub) {
        var subCount = this._subscriptions[sub.room] || 0;
        if (!subCount) {
            debug("tried to unsubscribe from ".concat(sub.room, ", but no subscriptions exist"));
            // continue regardless
        }
        if (subCount <= 1) {
            this.sio.emit('unsubscribe', { room: sub.room });
            delete this._subscriptions[sub.room];
            debug("unsubscribed to ".concat(sub.room));
        }
        else {
            this._subscriptions[sub.room] = subCount - 1;
            debug("skipping unsubscribe to ".concat(sub.room, " because there are still ").concat(subCount - 1, " subscribers"));
        }
        this.sio.off(sub.room, sub.listener);
    };
    SioClient.prototype.subscribeBeaconState = function (listener) {
        return this.subscribe('/beacons', listener);
    };
    SioClient.prototype.subscribeBuildingMap = function (listener) {
        return this.subscribe("/building_map", listener);
    };
    SioClient.prototype.subscribeDoorState = function (doorName, listener) {
        return this.subscribe("/doors/".concat(doorName, "/state"), listener);
    };
    SioClient.prototype.subscribeDoorHealth = function (doorName, listener) {
        return this.subscribe("/doors/".concat(doorName, "/health"), listener);
    };
    SioClient.prototype.subscribeLiftState = function (liftName, listener) {
        return this.subscribe("/lifts/".concat(liftName, "/state"), listener);
    };
    SioClient.prototype.subscribeLiftHealth = function (liftName, listener) {
        return this.subscribe("/doors/".concat(liftName, "/health"), listener);
    };
    SioClient.prototype.subscribeDispenserState = function (guid, listener) {
        return this.subscribe("/dispensers/".concat(guid, "/state"), listener);
    };
    SioClient.prototype.subscribeDispenserHealth = function (guid, listener) {
        return this.subscribe("/dispensers/".concat(guid, "/health"), listener);
    };
    SioClient.prototype.subscribeIngestorState = function (guid, listener) {
        return this.subscribe("/ingestors/".concat(guid, "/state"), listener);
    };
    SioClient.prototype.subscribeIngestorHealth = function (guid, listener) {
        return this.subscribe("/ingestors/".concat(guid, "/health"), listener);
    };
    SioClient.prototype.subscribeFleetState = function (name, listener) {
        return this.subscribe("/fleets/".concat(name, "/state"), listener);
    };
    SioClient.prototype.subscribeTaskState = function (taskId, listener) {
        return this.subscribe("/tasks/".concat(taskId, "/state"), listener);
    };
    SioClient.prototype.subscribeTaskLogs = function (taskId, listener) {
        return this.subscribe("/tasks/".concat(taskId, "/log"), listener);
    };
    SioClient.prototype.subscribeAlerts = function (listener) {
        return this.subscribe("/alerts", listener);
    };
    return SioClient;
}());
exports.SioClient = SioClient;
__exportStar(require("./openapi"), exports);
